import React, { useEffect } from 'react';
import video from '../assets/intro.mp4'; // Adjust the path to your video file
import AOS from 'aos';
import 'aos/dist/aos.css';

const About = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 }); // Initialize AOS with desired options
  }, []);

  return (
    <div id='about' className="bg-white py-14">
      <div className="container mx-auto px-4">
        <div className="md:flex md:flex-row md:justify-center md:items-center">
          <div className="md:w-1/2 lg:w-2/3 md:mr-8">
            <video className="h-full w-full rounded-lg" controls>
              <source src={video} type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
          <div data-aos="fade-left" className="md:w-1/2 lg:w-1/3 md:ml-8 mt-8 md:mt-0">
            <p className='text-[#00df9a] font-bold'>Who We Are</p>
            <h1 className="text-3xl font-bold mt-3 mb-4">ABOUT US</h1>
            <p className="py-2 mt-4 ">
              We are a setup comprising of experience and exuberance collectively creating synergy in our working environment. We specialize in bringing ideas to life, creating products, and reverse-engineering hi-tech systems.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
